// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PremiumButton-cls1___4ca0ed0b1407d1c0385{/*!*/}.PremiumButton-cls2__bf54cae683b879e3a0ce{margin-right:8px;width:22px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PremiumButton-cls1___4ca0ed0b1407d1c0385",
	"cls2": "PremiumButton-cls2__bf54cae683b879e3a0ce PremiumButton-cls1___4ca0ed0b1407d1c0385"
};
export default ___CSS_LOADER_EXPORT___;
